import React, {Fragment, useState, useEffect} from "react";

import {Row, Col} from "react-bootstrap";
import {useTranslation} from 'react-i18next';
import Cookies from 'js-cookie';
import {Checkmark} from 'react-checkmark';
import axios from "axios";

import { loadSanadBranding } from '../utils/loadSanadBranding';
const { config } = require('../../api/api')

function SanadOrderSuccess() {

    const base_url = config.baseURL;
    const [userData, setUserData] = useState(false);

    const vendor_key="c3VwZXJqZXRfc2FuYWRfcGVyc29uYWxfYWNjaWRlbnRfdmVuZG9yX2tleQ==";

 
    const [order_id, setOrder] = useState('');

    const [loading,setLoading]=useState(true);

    // const [orderData, setOrderData] = useState(false);
    // useEffect(() => {
    //     // debugger;
    //     const storedOrderString = sessionStorage.getItem('orderResult');
    //     if (storedOrderString) {
    //         const storedOrder = JSON.parse(storedOrderString);
    //         setOrderData(storedOrder);
    //     }
    // }, []);


    // useEffect(() => {

    //     // debugger;

    //     const storedUserString = Cookies.get('userData'); //sessionStorage.getItem('userData')
    //     if (storedUserString !== undefined) {
    //         const storedUser = JSON.parse(storedUserString);
    //         setUserData(storedUser);
    //     }
    // }, []);

    const [usrtok,setUsrtok]=useState("");


     useEffect(() => {

    loadSanadBranding();

  }, []);

  
    useEffect(()=>{

        const  get_user_details= sessionStorage.getItem("user_details");
        if(get_user_details){
            const parse_data =JSON.parse(get_user_details);
            setUsrtok(parse_data.access_token);
        }
  
    },[])



    const {t,i18n} = useTranslation(); 
    const [lnstr,setlnstr] = useState("en");
    
     useEffect(()=>{
              const getVisaDetails=sessionStorage.getItem("visaInfo");
            
              if(getVisaDetails){
                const parseVisaInfo=JSON.parse(getVisaDetails);
              if(parseVisaInfo?.locale){
              i18n.changeLanguage(parseVisaInfo?.locale)
              setlnstr(parseVisaInfo?.locale);
              }
              }
            },[])
        
        
             // Function to update HTML dir attribute based on language
              const updateHtmlDirAttribute = () => {
                document.documentElement.dir = i18n.dir(); // Set document direction
              };
            
              // Update HTML dir attribute when component mounts and language changes
              useEffect(() => {
                updateHtmlDirAttribute();
              }, [i18n.language]);
    

    const urlSearchString = window.location.search;

    const uparams = new URLSearchParams(urlSearchString);
   
//    setOrder(order);

    const [vendorKey, setVendorKey] = useState('');
    useEffect(()=>{
        const order =uparams.get('orderid');
        setOrder(order);
    },[]);

  


    const [OrderDetails, setOrderDetails] = useState('');
    const [OrderID, setOrderID] = useState('');
    const [CreatedDate, setCreatedDate] = useState('');
    const [PaymentStatus, setPaymentStatus] = useState('');
    const [OrderSts, setOrderSts] = useState('');
    const [ApplicationSts, setApplicationSts] = useState('');
    const [ApplicationID, setApplicationID] = useState('');
    const [ProcessingSts, setProcessingSts] = useState('');
    const [userDetails,setUserDetails]=useState(null);
    const [backUrl,setBackUrl]=useState("");


    useEffect(() => {

        if (vendor_key !== '') {
           
           try{
            var GivenData = {
                'order_id': uparams.get('orderid')
                
            }

            var vkData = GivenData;
            // debugger

            fetch(base_url+'/get_sanad_visa_order_details', {
                method: 'POST',
                headers: {
                    "Authorization":"Bearer "+vendor_key,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(vkData),
            })
                .then(response => response.json())
                .then(data => {
                    // debugger
                    console.log(data.result.order)

                    setOrderDetails(data.result.order)
                    setOrderID(data.result.order.id)
                    setCreatedDate(data.result.order.created_at)
                    setPaymentStatus(data.result.order.payment_status)
                    setOrderSts(data.result.order.order_status)
                    setApplicationSts(data.result.order.applications[0].application_status)
                    setApplicationID(data.result.order.applications[0].id)
                    setProcessingSts(data.result.order.applications[0].processing_status)
                    const sanad_data=JSON.parse(data.result.order.sanad_data);
                    // debugger
                    if(sanad_data.return_url){
                    setBackUrl(sanad_data.return_url);
                    }

                })
                .catch(error => {
                    console.error('Error posting data:', error);
                });
            }catch(err){
                console.error("err : "+err);
            }
            finally{
                setTimeout(()=>{
                   setLoading(false);
                },1000)
            }
        }
    }, [ vendor_key, uparams.get('orderid')]);

    useEffect(()=>{
      const visa_user=  sessionStorage.getItem("visaInfo");
      if(visa_user!==undefined){
        const parseUserDetails=JSON.parse(visa_user);
        setUserDetails(parseUserDetails);
      }
    },[])

    const handleBackBtn = () => {
        const regex = /^(ftp|http|https):\/\/[^ "]+$/;
        var isValidUrl = regex.test(backUrl);

        if (isValidUrl) {
            window.location.href =
                backUrl +
                '?order_id=' + encodeURIComponent(OrderDetails?.order_id) +
                '&sanad_reference_no=' + encodeURIComponent(OrderDetails?.sanad_reference_no);
            // window.location.href =
            //     backUrl +
            //     '?order_id=' + OrderDetails?.order_id +
            //     '&sanad_reference_no=' + OrderDetails?.sanad_reference_no;
        } else {
            window.location.reload();
        }
    }


    return (
        <>
                <div className="container">
                <div style={{height:"80vh",alignContent:"center"}}>
                    <div className="row">

                        <Col md={3} className="text-center">
                        </Col>

                        <Col md={6} className="mt-4 mb-0">

                            <Checkmark/>
                            <br/>
                            <h3 className="h3" style={{textAlign: 'center'}}>

                                {t('Order')} {t('Placed')} {t('Successfully')}

                            </h3>

                            {/*<p style={{textAlign: 'center'}}>Order No : <b>{uparams.get('order_id')}</b></p>*/}
                            <br/>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <tr>
                                    <td style={{textAlign: 'left', width: '30%', fontWeight: 'bold', padding: '8px'}}>
                                        {t("Order")} {t("ID")}
                                    </td>
                                    <td style={{width: '1%', textAlign: 'left', fontWeight: 'bold', padding: '8px'}}>
                                        :
                                    </td>
                                    <td style={{textAlign: 'left', width: '69%', padding: '8px'}}>
                                        <b>{OrderDetails?.order_id}</b>
                                    </td>
                                </tr>
                                
                                <tr>
                                    <td style={{textAlign: 'left', width: '30%', fontWeight: 'bold', padding: '8px'}}>
                                        {t("Reference")} {t("No")}
                                    </td>
                                    <td style={{width: '1%', textAlign: 'left', fontWeight: 'bold', padding: '8px'}}>
                                        :
                                    </td>
                                    <td style={{textAlign: 'left', width: '69%', padding: '8px'}}>
                                        <b>{OrderDetails?.sanad_reference_no}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{
                                        textAlign: 'left',
                                        width: '30%',
                                        fontWeight: 'bold',
                                        padding: '8px'
                                    }}>{t("First")} {t("Name")}
                                    </td>
                                    <td style={{width: '1%', textAlign: 'left', fontWeight: 'bold', padding: '8px'}}>
                                        :
                                    </td>
                                    <td style={{textAlign: 'left', width: '69%', padding: '8px'}}>
                                        <b>{OrderDetails.first_name}</b></td>
                                </tr>
                                <tr>
                                    <td style={{
                                        textAlign: 'left',
                                        width: '30%',
                                        fontWeight: 'bold',
                                        padding: '8px'
                                    }}>{t("Last")} {t("Name")}
                                    </td>
                                    <td style={{width: '1%', textAlign: 'left', fontWeight: 'bold', padding: '8px'}}>
                                        :
                                    </td>
                                    <td style={{textAlign: 'left', width: '69%', padding: '8px'}}>
                                        <b>{OrderDetails.last_name}</b></td>
                                </tr>
                                <tr>
                                    <td style={{
                                        textAlign: 'left',
                                        width: '30%',
                                        fontWeight: 'bold',
                                        padding: '8px'
                                    }}>{t("Email")}
                                    </td>
                                    <td style={{width: '1%', textAlign: 'left', fontWeight: 'bold', padding: '8px'}}>
                                        :
                                    </td>
                                    <td style={{textAlign: 'left', width: '69%', padding: '8px'}}>
                                        <b>{OrderDetails.email}</b></td>
                                </tr>
                                <tr>
                                    <td style={{
                                        textAlign: 'left',
                                        width: '30%',
                                        fontWeight: 'bold',
                                        padding: '8px'
                                    }}>{t("Arrival")}
                                    </td>
                                    <td style={{width: '1%', textAlign: 'left', fontWeight: 'bold', padding: '8px'}}>
                                        :
                                    </td>
                                    <td style={{textAlign: 'left', width: '69%', padding: '8px'}}>
                                        <b>{OrderDetails.arrival}</b></td>
                                </tr>
                                <tr>
                                    <td style={{
                                        textAlign: 'left',
                                        width: '30%',
                                        fontWeight: 'bold',
                                        padding: '8px'
                                    }}>{t("Destination")}
                                    </td>
                                    <td style={{width: '1%', textAlign: 'left', fontWeight: 'bold', padding: '8px'}}>
                                        :
                                    </td>
                                    <td style={{textAlign: 'left', width: '69%', padding: '8px'}}>
                                        <b>{OrderDetails.destination}</b></td>
                                </tr>
                               
                            </table>
                          


                        </Col>

                        <Col md={12} className="text-center" style={{paddingTop:'10px',paddingBottom:"40px"}}>
                        <p><button style={{color:'green', textAlign:'right', fontWeight:'bold', paddingTop:'20px', fontSize:'22px',backgroundColor: "inherit"}} onClick={handleBackBtn}>{t("Go To Sanad")}</button></p>
                        </Col>


                    </div>
</div>
                </div>        
                {
  loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )
} 
        </>
    );
}

export default SanadOrderSuccess;